import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminNavbar from "../Component/AdminNavbar";
export const AdminProducts = () => {

    const [products, setProducts] = useState([]);
    const deleteProduct = async (id) => {

        const token = sessionStorage.getItem("token");

        console.log("DELETE CLICKED", id);

        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/product/del/${id}`,
            {
                method: "DELETE",
                headers: {
                    Authorization: "Bearer " + token
                }
            }
        );

        console.log("STATUS =", response.status);

        const text = await response.text();
        console.log("RESPONSE =", text);

        // window.location.reload();
    };
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/product/`)
            .then((res) => res.json())
            .then((data) => {
                console.log(data);
                setProducts(data);
            });
    }, []);

    return (
        <div className="container mt-5">

            <AdminNavbar />

            <h2>Admin Products</h2>

            <table className="table table-bordered mt-4">

                <thead>
                <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Price</th>
                    <th>Weight</th>
                    <th>Action</th>
                </tr>
                </thead>

                <tbody>
                {products.map((product) => (
                    <tr key={product.productid}>
                        <td>{product.productid}</td>
                        <td>{product.productName}</td>
                        <td>₹{product.price}</td>
                        <td>{product.weight}</td>
                        <td>
                            <button
                                className="btn btn-danger"
                                onClick={() => deleteProduct(product.productid)}
                            >
                                Delete
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>

            </table>

        </div>
    );
};